var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { put, call, takeLatest } from 'redux-saga/effects';
import { fromJS } from 'immutable';
import store from 'store';
import history from '@store/history';
import errorHandler from 'services/connection';
import { checkoutPos as checkoutAction, checkoutComplete, createSession as createSessionAction, getSession as getSessionAction, getSessionComplete, } from './actions';
export function checkout(api, action) {
    var body, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, call([api, api.post], "sessions/" + action.meta.id + "/checkout", action.payload)];
            case 1:
                body = (_a.sent()).body;
                return [4 /*yield*/, put(checkoutComplete(body))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                error_1 = _a.sent();
                return [4 /*yield*/, put(errorHandler(error_1, checkoutComplete, checkoutAction, action.payload, action.meta.id))];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
export function getSession(api, action) {
    var _a, deviceId, sessionId, body, error_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, deviceId = _a.deviceId, sessionId = _a.sessionId;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 8]);
                return [4 /*yield*/, call([api, api.get], "sessions/" + sessionId)];
            case 2:
                body = (_b.sent()).body;
                store.set('sessionId', body.uuid);
                return [4 /*yield*/, put(getSessionComplete(fromJS(body)))];
            case 3:
                _b.sent();
                return [3 /*break*/, 8];
            case 4:
                error_2 = _b.sent();
                if (!(error_2.response && error_2.response.status === 404)) return [3 /*break*/, 6];
                return [4 /*yield*/, put(createSessionAction(deviceId))];
            case 5:
                _b.sent();
                history.push('/');
                _b.label = 6;
            case 6: return [4 /*yield*/, put(errorHandler(error_2, getSessionComplete, getSessionAction, action.payload))];
            case 7:
                _b.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
export function createSession(api, action) {
    var body, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, call([api, api.post], "sessions", {
                        deviceId: action.payload,
                    })];
            case 1:
                body = (_a.sent()).body;
                store.set('sessionId', body.uuid);
                return [4 /*yield*/, put(getSessionComplete(fromJS(body)))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                error_3 = _a.sent();
                return [4 /*yield*/, put(errorHandler(error_3, getSessionComplete, createSessionAction, action.payload))];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
export function sessionGetWatcher(_a) {
    var api = _a.api;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, takeLatest('GET_SESSION', getSession, api)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export function sessionCreateWatcher(_a) {
    var api = _a.api;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, takeLatest('CREATE_SESSION', createSession, api)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export function sessionCheckoutWatcher(_a) {
    var api = _a.api;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, takeLatest('CHECKOUT_POS', checkout, api)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
